import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-table",
  "data-qa": "cart-table-item-list:box"
}
const _hoisted_2 = { class: "gfu-table__head" }
const _hoisted_3 = { class: "gfu-table__row" }
const _hoisted_4 = { class: "gfu-table__cell _flexb50 _screen--all _screen--not-s" }
const _hoisted_5 = { class: "gfu-table__cell _flexb55 _flexb75--s _flexb60--m _screen--none _screen--s" }
const _hoisted_6 = { class: "gfu-table__cell _tac _flexb15 _flexb10--s _screen--all _screen--not-m" }
const _hoisted_7 = { class: "gfu-table__cell _tac _flexb10 _screen--none _screen--m gfu-table__cell--actions" }
const _hoisted_8 = { class: "gfu-table__cell _tar _flexb35 _flexb25--s _screen--all _screen--not-m" }
const _hoisted_9 = { class: "gfu-table__cell _tar _flexb15 _screen--none _screen--m" }
const _hoisted_10 = {
  key: 0,
  class: "gfu-table__cell _tar _flexb5 _screen--none _screen--s"
}
const _hoisted_11 = {
  key: 0,
  class: "_ml-1"
}
const _hoisted_12 = {
  key: 0,
  class: "gfu-hd gfu-hd--light _ttu",
  "data-qa": "cart-table:PreDefinedItems"
}
const _hoisted_13 = {
  key: 0,
  class: "gfu-hd gfu-hd--light _ttu",
  "data-qa": "cart-table:YourItems"
}
const _hoisted_14 = {
  key: 1,
  class: "gfu-hd gfu-hd--light _ttu",
  "data-qa": "cart-table:UnpaidItems"
}
const _hoisted_15 = {
  key: 0,
  class: "gfu-hd gfu-hd--light _ttu",
  "data-qa": "cart-table:OriginalOrder"
}
const _hoisted_16 = {
  key: 1,
  class: "gfu-hd gfu-hd--light _ttu",
  "data-qa": "cart-table:ItemsAddedOn"
}
const _hoisted_17 = { class: "gfu-field__label _tal" }
const _hoisted_18 = {
  key: 0,
  class: "gfu-table__custom-items"
}
const _hoisted_19 = { class: "gfu-table__footer gfu-table__footer--light gfu-table__footer--lightweight" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notificator = _resolveComponent("notificator")
  const _component_cart_table_item_row = _resolveComponent("cart-table-item-row")
  const _component_cart_table_set_item_row = _resolveComponent("cart-table-set-item-row")
  const _component_cart_table_custom_item_row = _resolveComponent("cart-table-custom-item-row")
  const _component_cart_table_total_row = _resolveComponent("cart-table-total-row")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notificator, {
      ref: "notify",
      singular: true
    }, null, 512 /* NEED_PATCH */),
    ($options.isCartTableVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Resources.YourPledge.CartTableDetailsHeader), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.YourPledge.CartTableItemDetailsHeader), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.YourPledge.CartTableQuantityShortHeader), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Resources.YourPledge.CartTableQuantityHeader), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.Resources.YourPledge.CartTablePriceHeader), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.Resources.YourPledge.CartTableTotalPriceHeader), 1 /* TEXT */),
              (_ctx.model.allowEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['gfu-table__body gfu-table__body--no-scroll',
                          {'gfu-table__body--underlined': _ctx.model.groupedOrderItems.length <= 1 && _ctx.model.customOrderItems.length === 0}]),
            "data-qa": "cart-table"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.groupedOrderItems, (paymentGroup, groupNumber) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'grouped-order-item-' + groupNumber,
                class: _normalizeClass({ 'gfu-table__row-group': _ctx.model.groupedOrderItems.length > 1 })
              }, [
                (_ctx.model.groupedOrderItems.length > 1 || paymentGroup.isImported)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (paymentGroup.isImported)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.Resources.YourPledge.CartTablePredefinedItemsTitle), 1 /* TEXT */))
                        : (paymentGroup.paymentStatus === _ctx.orderItemPaymentStatuses.unpaid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.model.groupedOrderItems.find(g => g.isImported))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.Resources.YourPledge.CartTableYourItemsTitle), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.Resources.YourPledge.CartTableUnpaidItemsTitle), 1 /* TEXT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (groupNumber === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.Resources.YourPledge.CartTableOriginalOrderTitle), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.Resources.format(_ctx.Resources.YourPledge.CartTableItemsAddedOnTitle, paymentGroup.paymentDate)), 1 /* TEXT */))
                            ], 64 /* STABLE_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentGroup.orderItemIDs, (orderItemID) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'item-row-' + orderItemID
                  }, [
                    _createVNode(_component_cart_table_item_row, {
                      ref_for: true,
                      ref: 'item-row-' + orderItemID,
                      "allow-editing": _ctx.model.allowEditing,
                      "currency-symbol": _ctx.model.cart.currencySymbol,
                      "order-item-id": orderItemID,
                      "restricted-item-list": $options.cartRestrictedItems,
                      "payment-group": groupNumber,
                      "product-order-items": _ctx.model.productOrderItems,
                      "project-id": $props.projectId,
                      "show-net-price": _ctx.model.cart.handleTax,
                      "show-tax-value": $options.isTaxValueVisible,
                      onCartModified: $options.onCartModified,
                      onError: $options.onError,
                      "data-qa": `cart-table-order-item:${orderItemID}`
                    }, null, 8 /* PROPS */, ["allow-editing", "currency-symbol", "order-item-id", "restricted-item-list", "payment-group", "product-order-items", "project-id", "show-net-price", "show-tax-value", "onCartModified", "onError", "data-qa"]),
                    (_ctx.model.productOrderItems.find(oi => oi.orderItemID === orderItemID).product.type === _ctx.productTypes.set)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 'set-item-table-' + orderItemID,
                          class: "gfu-table gfu-table--nested"
                        }, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.Resources.YourPledge.CartTableSetContentLabel), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getSortedSetItems(orderItemID), (setItem) => {
                            return (_openBlock(), _createBlock(_component_cart_table_set_item_row, {
                              key: 'set-item-row-' + setItem.orderItemID,
                              ref_for: true,
                              ref: 'set-item-row-' + setItem.orderItemID,
                              "allow-editing": _ctx.model.allowEditing,
                              "restricted-item-list": $options.cartRestrictedItems,
                              "order-item-id": setItem.orderItemID,
                              "payment-group": groupNumber,
                              "product-order-items": _ctx.model.productOrderItems,
                              "project-id": $props.projectId,
                              onCartModified: $options.onCartModified,
                              onError: $options.onError,
                              "data-qa": 'cart-table-order-item:'+ setItem.orderItemID
                            }, null, 8 /* PROPS */, ["allow-editing", "restricted-item-list", "order-item-id", "payment-group", "product-order-items", "project-id", "onCartModified", "onError", "data-qa"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.model.productOrderItems.find(oi => oi.orderItemID === orderItemID).product.type === _ctx.productTypes.set)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 'set-item-row-striped' + orderItemID,
                          class: "gfu-table__row _screen--none"
                        }))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            (_ctx.model.customOrderItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.customOrderItemsWithoutDiscount, (customOrderItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'custom-item-row-' + customOrderItem.orderItemID
                    }, [
                      _createVNode(_component_cart_table_custom_item_row, {
                        ref_for: true,
                        ref: 'other-fee-row-' + customOrderItem.orderItemID,
                        "allow-editing": _ctx.model.allowEditing,
                        "currency-symbol": _ctx.model.cart.currencySymbol,
                        "order-item-id": customOrderItem.orderItemID,
                        "project-id": $props.projectId,
                        "product-order-items": [customOrderItem],
                        "show-net-price": _ctx.model.cart.handleTax,
                        "show-tax-value": $options.isTaxValueVisible,
                        onCartModified: $options.onCartModified,
                        "data-qa": 'cart-table-order-item:'+ customOrderItem.orderItemID
                      }, null, 8 /* PROPS */, ["allow-editing", "currency-symbol", "order-item-id", "project-id", "product-order-items", "show-net-price", "show-tax-value", "onCartModified", "data-qa"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_cart_table_total_row, {
              "allow-editing": _ctx.model.allowEditing,
              "display-text": _ctx.Resources.YourPledge.CartTableSubtotalRowLabel,
              quantity: _ctx.model.totalQuantity,
              "is-highlighted": !$options.showTotals,
              "currency-symbol": _ctx.model.cart.currencySymbol,
              "use-net-value": _ctx.model.cart.handleTax,
              "net-value": _ctx.model.cart.totalNetValueConverted,
              "gross-value": _ctx.model.cart.totalValueConverted
            }, null, 8 /* PROPS */, ["allow-editing", "display-text", "quantity", "is-highlighted", "currency-symbol", "use-net-value", "net-value", "gross-value"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}